import React from "react";

import "./FilterLabel.css";

export type Props = {
    title?: string;
    id?: string;
};

export default function FilterLabel(props: Props) {
    return props.title ? (
        <label className="FilterLabel" htmlFor={props.id}>
            {props.title}
        </label>
    ) : null;
}
